<ion-header>
  <ion-toolbar>
    <ion-title>{{ text | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
